import { graphql } from 'react-relay';
import { Environment, fetchQuery } from 'relay-runtime';

import { checkRefundHistoryQuery$data } from '@/__generated__/checkRefundHistoryQuery.graphql';
import { checkSearchStatusQuery$data } from '@/__generated__/checkSearchStatusQuery.graphql';
import { checkRefundHistory } from '@/graphql/query/tax-refund/check-refund-history';

export async function checkSearchStatus(relayEnvironment: Environment, corpType: 'INDIS' | 'CORPS') {
  let result: checkSearchStatusQuery$data['checkSearchStatus'] | null = null;

  try {
    const data = (await fetchQuery(
      relayEnvironment,
      graphql`
        query checkSearchStatusQuery($corpType: CorpTypeEnum!) {
          checkSearchStatus(corpType: $corpType) {
            result
            progress
            errors {
              code
              message
            }
            refundInfo {
              refundId
              refundStatus
              refundStage
              refundAmount
              snmcSpcTxreAmt
              cenSnmcTxreAmt
              empIncrEtrpTxamtDdcAmt
              intgEmpTxamtDdcAmt
              sctyInfeeTxamtDdcAmt
              reSearchRequestId
              businessInfo {
                hometaxBizName
                hometaxBizNo
                taxpayerName
              }
            }
            tritxRefundInfo {
              refundId
              refundStatus
              refundStage
              refundAmount
              tritxReSearchRequestId
              businessInfo {
                hometaxBizName
                hometaxBizNo
                taxpayerName
              }
            }
          }
        }
      `,
      {
        corpType
      }
    ).toPromise()) as checkSearchStatusQuery$data;

    result = {
      result: data?.checkSearchStatus.result,
      progress: data?.checkSearchStatus.progress,
      refundInfo: data?.checkSearchStatus.refundInfo,
      tritxRefundInfo: data?.checkSearchStatus.tritxRefundInfo,
      errors: data?.checkSearchStatus.errors
    };
  } catch {
    // nothing to do
  }

  return result;
}

export async function checkHasHistory(relayEnvironment: Environment) {
  let result: boolean = false;

  try {
    const data = (await fetchQuery(relayEnvironment, checkRefundHistory, {}).toPromise()) as checkRefundHistoryQuery$data;

    result = !!(data?.bznavRefund.user.indis || data?.bznavRefund.user.previousIndis || data?.bznavRefund.user.corps || data?.bznavRefund.user.tritxIndis);
  } catch {
    // nothing to do
  }

  return result;
}
